import styles from './DegradedBanner.module.scss';
import { buildDegradedBannerText, DEGRADED_GLYPH } from '../constants/reconciliationsCopy';
import type { ReconDegraded } from '../../../../../store/reconciliations/types';

interface DegradedBannerProps {
    degraded: ReconDegraded;
    reconLabelById: Record<string, string>;
}

/** Amber banner (D27a) — rendered between the drawer header and the first section, only when
 *  the payload is degraded; absent entirely otherwise (A-126b). */
function DegradedBanner({ degraded, reconLabelById }: Readonly<DegradedBannerProps>) {
    return (
        <div className={styles.DegradedBanner}>
            <span className={styles.Glyph}>{DEGRADED_GLYPH}</span>
            <span className={styles.Text}>{buildDegradedBannerText(degraded, reconLabelById)}</span>
        </div>
    );
}

export default DegradedBanner;
